// v3.4.091 — عرض مرفقات واتساب الأعمال داخل فقاعة الرسالة (صورة/ملصق/فيديو/صوت/مستند)
// src = رابط المرفق (الوارد الرئيسي: /api/wa-business/media/:id — البوابة: /api/portal/wa/media/:id?t=token)
import React from "react";

const PLACEHOLDER = /^\[(image|video|audio|document|sticker)\]$/;
// نص الرسالة المحفوظ لمرفق بلا تعليق هو «[video]» ونحوه — لا نعرضه عندما يظهر المرفق نفسه
export function isPlaceholderBody(body) { return PLACEHOLDER.test(String(body || "").trim()); }

export default function WaMedia({ m, src }) {
  if (!m?.media_id) return null;
  const t = m.message_type;
  const box = { marginBottom: 6, maxWidth: 320 };
  if (t === "image" || t === "sticker") {
    return (
      <a href={src} target="_blank" rel="noreferrer" style={{ ...box, display: "block" }} title="فتح الصورة">
        <img src={src} alt="" style={{ maxWidth: "100%", maxHeight: 320, borderRadius: 10, display: "block" }} />
      </a>
    );
  }
  if (t === "video") return <video src={src} controls preload="metadata" style={{ ...box, width: "100%", maxHeight: 320, borderRadius: 10, background: "#000", display: "block" }} />;
  if (t === "audio") return <audio src={src} controls preload="metadata" style={{ ...box, width: 260, display: "block" }} />;
  const dl = src + (src.includes("?") ? "&" : "?") + "download=1";
  return (
    <a href={dl} style={{ ...box, display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 10,
      background: "#eef2ff", color: "#3730a3", fontWeight: 700, fontSize: 12.5, textDecoration: "none" }} title="تنزيل المستند">
      📎 <span style={{ wordBreak: "break-all" }}>{m.media_filename || "مستند"}</span>
    </a>
  );
}
